import { Button } from "antd";
import FullPageLayout from "../../../../../templates/FullPageLayout";
import { useState } from "react";
import { NeedHelp } from "../../../../../atoms/CustomIcons";
import AddServices from "./AddServices";

interface PropsType {
  onClose: () => void;
}

export default function AddCustomService(props: PropsType) {
  const { onClose } = props;
  const location = window.location.pathname;
  const pathSegments = location.split("/");
  const companyId = pathSegments[pathSegments.length - 1];
  const serviceLineId = pathSegments[pathSegments.length - 2];
  const [loading, setLoading] = useState(false);

  console.log("type", onClose);

  return (
    <FullPageLayout loading={loading}>
      <Button className="btn-sm fixedTopBtn">
        <NeedHelp /> Need help?
      </Button>
      <AddServices
        setLoading={setLoading}
        companyId={companyId}
        serviceLineId={serviceLineId}
        onClose={onClose}
      />
    </FullPageLayout>
  );
}
